import React from "react";

import { visibilityStore } from "./store/VisibilityStore";
import { Container } from "../Container";
import { VisibilityMarken, IProps } from "./VisibilityMarken";

export const VisibilityMarkenWidget = (props: IProps): JSX.Element => (
	<Container store={visibilityStore}>
		<VisibilityMarken {...props} />
	</Container>
);
